/* eslint-disable react-refresh/only-export-components -- entry point, never hot-reloaded */
import { createRoot } from 'react-dom/client';
import './styles/globals.css';

const root = createRoot(document.getElementById('root')!);

// Boot guard. The Supabase client (src/db/supabase.ts) throws at IMPORT time when
// its env vars are missing — and because the whole app graph imports it, that
// throw happens before React can mount, leaving a blank white page with no clue
// why. So check the env HERE, before importing the app (and its Supabase client),
// and render an explanation instead of nothing. In production these are always
// set; this only ever fires on a local dev machine with no .env.
const hasEnv = !!import.meta.env.VITE_SUPABASE_URL && !!import.meta.env.VITE_SUPABASE_ANON_KEY;

if (hasEnv) {
    // Deferred so this module doesn't pull in the throwing Supabase client until
    // we know the env is present.
    import('./App').then(({ App }) => root.render(<App />));
} else {
    root.render(<MissingEnv />);
}

function MissingEnv() {
    const mono = "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace";
    return (
        <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '2rem', background: '#fcfbfa', color: '#1c1917', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
            <div style={{ maxWidth: '34rem' }}>
                <p style={{ fontSize: '.72rem', fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: '#0f766e', margin: '0 0 .5rem' }}>Karr Travel — setup</p>
                <h1 style={{ fontSize: '1.5rem', margin: '0 0 .75rem', fontWeight: 600 }}>Missing Supabase keys</h1>
                <p style={{ color: '#57534e', lineHeight: 1.6, margin: '0 0 1rem' }}>
                    The app can’t start without its database connection. Create a file named <code style={{ fontFamily: mono, background: '#f0eee9', padding: '.1em .35em', borderRadius: 4 }}>.env.local</code> in the project root with these two lines, then restart the dev server:
                </p>
                <pre style={{ background: '#f5f4f1', border: '1px solid #e7e3dd', borderRadius: 8, padding: '1rem', overflowX: 'auto', fontFamily: mono, fontSize: '.85rem', lineHeight: 1.7, margin: '0 0 1rem' }}>VITE_SUPABASE_URL=https://YOUR-PROJECT.supabase.co
VITE_SUPABASE_ANON_KEY=sb_publishable_…</pre>
                <p style={{ color: '#78716c', lineHeight: 1.6, margin: 0, fontSize: '.9rem' }}>
                    Both values are the same ones the deployed site uses — find them in your Supabase dashboard under <b>Settings → API</b>, or copy them from your Cloudflare Worker’s <b>Settings → Build → Variables</b>. Restart the dev server after saving; Vite doesn’t pick up new <code style={{ fontFamily: mono }}>.env</code> files while running.
                </p>
            </div>
        </div>
    );
}
